import { Component, HostBinding, Inject, Input, OnInit } from '@angular/core';
import { Product, ProductVariant } from '../data/models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { isNil } from 'lodash';
import { DataService } from '../data/data.service';
import { SCREEN_LAYOUT, ScreenLayout } from '../core/layout/layout.provider';

@Component({
    selector: 'app-product-details[product]',
    styles: [`
    :host {
      display: flex;
      width: 100%;
      height: 100%;
    }
  `],
    template: `
    <div class="modal-header">
      <h4 class="modal-title" id="exampleModalLabel" i18n>Produktdetails</h4>
      <button type="button" class="btn-close" aria-label="Close" i18n-aria-label (click)="modalService.close()"></button>
    </div>
    <div class="modal-body d-flex p-0">
      <div class="d-flex flex-column border-end col-md-8 h-100" *ngIf="layout === 'desktop'">
        <app-product-details-variant-list class="flex-grow-1 flex-shrink-1 h-100 list-group rounded-top-0 rounded-bottom-0 d-flex overflow-y-auto"
          [variants]="product?.variants || []"
          [selectedVariant]="selectedVariant"
          (variantSelected)="selectVariant($event)"></app-product-details-variant-list>
        <div class="flex-grow-0 flex-shrink-0 d-flex justify-content-end m-3">
          <button class="btn btn-info btn-lg ps-5 pe-5" (click)="addProductToCart()" i18n>Hinzufügen</button>
        </div>
      </div>

      <div *ngIf="layout === 'mobile'" class="d-flex flex-column flex-grow-1">
        <app-product-variant-details [selectedVariant]="selectedVariant"
                                     class="flex-column flex-grow-1 align-items-center pt-3 d-flex overflow-y-auto">
          <span class="fw-bold w-100 p-3" i18n>Produktvarianten</span>
          <app-product-details-variant-list class="flex-grow-1 flex-shrink-1 h-100 w-100 list-group rounded-top-0 rounded-bottom-0 d-flex"
                                            [variants]="product?.variants || []"
                                            [selectedVariant]="selectedVariant"
                                            (variantSelected)="selectVariant($event)"></app-product-details-variant-list>
        </app-product-variant-details>
        <div class="d-flex flex-grow-0 flex-shrink-0 justify-content-center m-3">
          <button class="btn btn-info btn-lg ps-5 pe-5" (click)="addProductToCart()" i18n>Hinzufügen</button>
        </div>
      </div>

      <app-product-variant-details [selectedVariant]="selectedVariant" *ngIf="layout === 'desktop'"
           class="flex-column flex-grow-1 d-flex align-items-center pt-3 d-flex overflow-y-auto"></app-product-variant-details>
    </div>
  `,
    standalone: false
})
export class ProductDetailsComponent implements OnInit {
  @Input() product?: Product;
  selectedVariant: ProductVariant | null = null;

  @HostBinding('class.d-flex') dFlex = true;
  @HostBinding('class.flex-nowrap') noWrap = true;
  @HostBinding('class.flex-column') flexColumn = true;
  @HostBinding('class.flex-grow-1') flexGrow = true;

  constructor(public readonly modalService: NgbActiveModal,
              private readonly dataService: DataService,
              @Inject(SCREEN_LAYOUT) public layout: ScreenLayout) {
  }

  ngOnInit(): void {
    this.selectVariantByProductId();
  }

  selectVariantByProductId() {
    const variant = this.product?.variants.find(v => v.id === this.product?.id);
    if (!isNil(variant)) {
      this.selectVariant(variant);
    }
  }

  selectVariant(variant: ProductVariant) {
    this.selectedVariant = variant;
  }

  addProductToCart() {
    if (!this.selectedVariant) {
      return;
    }

    this.dataService.addToCart(this.selectedVariant.id);
    this.modalService.close();
  }
}
